import {FLORIST_API} from '../constants/Constants'
import API from './API'

function getFloristsByFloristCodeAndExcludedContracts(search) {
  return API({
    name: 'fleuristes',
    method: 'get',
    url: `${FLORIST_API}/contracts/excluded?floristCode=${search}`
  })
}

export default {
  getFloristsByFloristCodeAndExcludedContracts,
}
